export default [
  {
    component: () => import("src/pages/ElectionDashboard.vue"),
    path: "/",
  },
];
